<template>
  <div ref="rootelement" class="vue-friendly-iframe"></div>
</template>

<script>
//this is instead of the 'vue-friendly-iframe' dependency - in single vue component
import { defineComponent } from "vue";

export default defineComponent({
  name: "VueFriendlyIframe",
  props: {
    src: {
      type: String,
      required: true
    },
    crossorigin: {
      type: String,
      required: false,
      default: "anonymous"
    },
    loading: {
      type: String,
      required: false,
      default: ""
    },
    target: {
      type: String,
      required: false,
      default: "_parent"
    },
    className: {
      type: String,
      required: false
    },
    allow: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    sandbox: {
      type: String,
      required: false
    }
  },
  data() {
    const nonceMatch = document
      .querySelector('meta[http-equiv="Content-Security-Policy"]')
      ?.content?.match(/style-src\s+[^;]*'nonce-([^']*)'/);
    const cspNonce = nonceMatch?.length > 1 ? nonceMatch[1] : undefined;
    return {
      iframeEl: null,
      iframeLoadedMessage: `IFRAME_LOADED_${this.generateGuid()}`,
      iframeOnReadyStateChangeMessage: `IFRAME_ON_READ_STATE_CHANGE_${this.generateGuid()}`,
      cspNonce: cspNonce
    };
  },
  computed: {},
  watch: {
    src() {
      this.reinitIframe(this);
    }
  },
  methods: {
    //uuid
    P: function (str, length) {
      return ("0000000000000000" + str).slice(-length);
    },
    R: function () {
      return this.P((~~(Math.random() * 0x1000)).toString(16), 3);
    },
    uuid: function () {
      var now = new Date();
      var time = this.P(
        (
          10000 *
          (+new Date(now.getTime() - now.getTimezoneOffset() * 60000) +
            12219292800000)
        ).toString(16),
        16
      );
      return (
        time.slice(8, 16) +
        "-" +
        time.slice(4, 8) +
        "-1" +
        time.slice(1, 4) +
        "-8" +
        this.R() +
        "-" +
        this.R() +
        this.R() +
        this.R() +
        this.R()
      );
    },
    //eof uuid

    generateGuid: function () {
      return this.uuid();
    },
    debounce: function (func, wait, immediate) {
      let timeout;

      return function () {
        const context = this;

        const args = arguments;

        const later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
      };
    },
    removeIframe() {
      while (this.$refs.rootelement.firstChild) {
        this.$refs.rootelement.removeChild(this.$refs.rootelement.firstChild);
      }
    },
    setIframeUrl() {
      if (this.iframeEl.contentWindow === null) {
        setTimeout(this.setIframeUrl);
        return;
      }
      const iframeDoc = this.iframeEl.contentWindow.document;
      iframeDoc.open().write(
        `
          <body/>
          <script nonce="${this.cspNonce}" async>
            // Add load event listener to handle redirection and postMessage
            window.addEventListener('load', function() {
              window.location.replace('${this.src}');
              parent.postMessage('${this.iframeLoadedMessage}', '*');
            });

            // Document readyState change event listener
            window.document.onreadystatechange = function () {
              if (window.document.readyState === 'complete') {
                parent.postMessage('${this.iframeOnReadyStateChangeMessage}', '*');
              }
            };
          <\/script>
          `
      );

      iframeDoc.close(); //iframe onload event happens
    },
    reinitIframe: function () {
      this.debounce((vm) => {
        vm.removeIframe();
        vm.initIframe();
      }, 200);
    },

    initIframe() {
      var t = this;
      this.iframeEl = document.createElement("iframe");
      this.iframeEl.classList.add("iframe-style-1");
      if (this.src) this.iframeEl.setAttribute("iframe-src", this.src);
      if (this.className) this.iframeEl.setAttribute("class", this.className);
      if (this.class) this.iframeEl.setAttribute("class", this.class);
      if (this.crossorigin)
        this.iframeEl.setAttribute("crossorigin", this.crossorigin);
      if (this.target) this.iframeEl.setAttribute("target", this.target);
      if (this.allow) this.iframeEl.setAttribute("allow", this.allow);
      if (this.name) this.iframeEl.setAttribute("name", this.name);
      if (this.title) this.iframeEl.setAttribute("title", this.title);
      if (this.sandbox) this.iframeEl.setAttribute("sandbox", this.sandbox);
      if (this.loading) this.iframeEl.setAttribute("loading", this.loading);

      const styleTag = document.createElement("style");
      styleTag.setAttribute("nonce", this.cspNonce);
      styleTag.textContent =
        ".iframe-style-1 {visibility: hidden; position: absolute; top: -99999px; border: none;} .iframe-style-2 {visibility: visible; border: none;}";

      this.$refs.rootelement.appendChild(styleTag);
      this.$refs.rootelement.appendChild(this.iframeEl);

      setTimeout(function () {
        t.setIframeUrl();
      }, 200);
    },
    listenForEvents() {
      // Create IE + others compatible event handler
      const eventMethod = window.addEventListener
        ? "addEventListener"
        : "attachEvent";
      const eventer = window[eventMethod];
      const messageEvent =
        eventMethod === "attachEvent" ? "onmessage" : "message";

      // Listen to message from child window
      eventer(
        messageEvent,
        (event) => {
          if (event.data === this.iframeLoadedMessage) {
            this.$emit("iframe-load");
            this.iframeEl.classList.add("iframe-style-2");
          }

          if (event.data === this.iframeOnReadyStateChangeMessage) {
            this.$emit("load");
          }
        },
        false
      );
    }
  },
  mounted() {
    this.listenForEvents();

    this.initIframe();
  }
});
</script>
